import React, { useEffect } from "react";
import { TextField } from "@mui/material";
import { useField, useFormikContext } from "formik";

const FTextField = ({
  name,
  depends = false,
  dependsOn = null,
  dependsOnValue = null,
  ...otherProps
}) => {
  const [field, meta, functions] = useField(name);
  const { setFieldValue, values } = useFormikContext();

  const configTextfield = {
    ...field,
    ...otherProps,
    fullWidth: true,
    variant: "outlined",
  };

  if (meta && meta.touched && meta.error) {
    configTextfield.error = true;
    configTextfield.helperText = meta.error;
  }
  // if (depends) {
  //   console.log(depends, dependsOn, values[dependsOn]);
  // }
  useEffect(() => {
    if (depends && !values[dependsOn].includes(dependsOnValue)) {
      functions.setValue("");
    }
  }, [values[dependsOn]]);

  if (!depends || (depends && values[dependsOn].includes(dependsOnValue))) {
    return <TextField {...configTextfield} />;
  }

  return <></>;
};

export default React.memo(FTextField);
